import React, {useContext} from 'react';

import Teaser from '~/src/components/teaser/Teaser';

import {TeaserLayoutProps} from '~/src/components/teaser/layout/default/TeaserLayoutDefault';
import {SettingsContext} from '~/src/components/context/SettingsContext';
import {SiteArea} from '~/src/utilities/constants/navigation';
import {getAdUnitName} from '~/src/utilities/helpers/ad';
import {getNextCounter} from '~/src/utilities/helpers/counters';
import {classNames} from '~/src/utilities/helpers/css';
import {AdFormat} from '~/src/utilities/constants/formats';
import {TeaserTypes} from '~/src/utilities/constants/types';
import {createFormat} from '~/src/utilities/feed/format';
import initPolyglot from '~/src/utilities/libs/polyglot';

import css from './TeaserLayoutRelatedContent.module.scss';
import i18nStrings from './TeaserLayoutRelatedContent.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

const TeaserLayoutRelatedContent = ({showTitle, colorScheme, children}: TeaserLayoutProps) => {
    const {siteArea} = useContext(SettingsContext);
    const headerClassNames = classNames(css, 'titleHeader', siteArea, colorScheme);
    const teaserClassNames = classNames(css, 'teasers', siteArea, colorScheme);

    const title = getTranslation(siteArea === SiteArea.VIDEO ? 'relatedVideos' : 'relatedArticles');

    const elements = React.Children.toArray(children);

    // insert ad every 4th teaser
    for (let i = 4; i < elements.length; i += 5) {
        elements.splice(
            i,
            0,
            <Teaser
                type={TeaserTypes.AD}
                key={`special_${i}`}
                adUnitName={getAdUnitName('inside-full-recommender', getNextCounter('inside-full-recommender'))}
                format={createFormat(AdFormat.INSIDE_FULL_RECOMMENDER_POS)}
            />
        );
    }

    return (
        <React.Fragment>
            {showTitle && (
                <div className={headerClassNames}>
                    <h1 className={css.title}>{title}</h1>
                </div>
            )}

            <div className={teaserClassNames}>{elements}</div>
        </React.Fragment>
    );
};

export default TeaserLayoutRelatedContent;
